export default [
  {
    path: '/signup',
    component: () => import('@/pages/signup/Index.vue'),
    children: [
      {
        name: 'signup',
        path: '',
        meta: { requireSignin: false, design: { classes: ['fill-height', 'bg--linear-gradient'] } },
        component: () => import('@/pages/signup/Signup.vue'),
        // redirect: 'agreements/nice',
      },
      {
        name: 'signup/agreements/kcs',
        path: 'agreements/kcs',
        meta: { requireSignin: false, design: { classes: ['px-0'] } },
        component: () => import('@/pages/signup/AgreementsKcs.vue'),
      },
      {
        name: 'signup/agreements/nice',
        path: 'agreements/nice',
        meta: { requireSignin: false, design: { classes: ['px-0'] } },
        component: () => import('@/pages/signup/AgreementsNice.vue'),
      },
      {
        name: 'signup/agreements/service',
        path: 'agreements/service',
        component: () => import('@/pages/signup/Agreements.vue'),
      },
      {
        name: 'signup/documents',
        path: 'documents',
        meta: { design: { classes: ['px-0'] } },
        component: () => import('@/pages/documents/DocumentsVer2.vue'),
      },
      {
        name: 'signup/bank/collections',
        path: 'bank/collections',
        meta: { design: { classes: ['px-0'] } },
        component: () => import('@/pages/bank/Collections.vue'),
      },
      {
        name: 'signup/bank/withdrawal',
        path: 'bank/withdrawal',
        meta: { design: { classes: ['px-0'] } },
        component: () => import('@/pages/bank/Withdrawal.vue'),
      },
      {
        name: 'signup/woori-crowd/application',
        path: 'woori-crowd/:uuid/application',
        meta: { design: { classes: ['px-0'] } },
        props: (route) => ({ uuid: route.params.uuid }),
        component: () => import('@/pages/signup/WooriCrowdApplication.vue'),
      },
      {
        path: 'certification',
        component: () => import('@/pages/documents/Certification.vue'),
        children: [
          {
            name: 'signup/certification',
            path: '',
            redirect: 'income',
          },
          {
            name: 'signup/certification/income',
            path: 'income',
            meta: { design: { classes: ['px-0'] } },
            component: () => import('@/pages/documents/IncomeCertification.vue'),
          },
          {
            name: 'signup/certification/confirm',
            path: 'confirm',
            meta: { design: { classes: ['px-0'] } },
            component: () => import('@/pages/documents/IncomeCertificationConfirm.vue'),
          },
        ],
      },
      {
        name: 'signup/limit-transaction',
        path: 'limit-transaction',
        meta: { design: { classes: ['px-0'] } },
        component: () => import('@/pages/documents/DocumentLimitTransaction.vue'),
      },
    ],
  },
  {
    name: 'signup/organization',
    path: '/signup/organization',
    component: () => import('@/pages/signup/Organization.vue'),
  },
  {
    name: 'signup/step1',
    path: '/signup/step1',
    component: () => import('@/pages/signup/Step1.vue'),
  },
  {
    name: 'signup/store',
    path: '/signup/store',
    component: () => import('@/pages/signup/Store.vue'),
  },
  {
    name: 'signup/problem',
    path: '/signup/problem',
    component: () => import('@/pages/signup/Problem.vue'),
  },
  {
    name: 'signup/manage',
    path: '/signup/manage',
    meta: { requireSignin: false, design: { classes: ['fill-height', 'bg--linear-gradient'] } },
    component: () => import('@/pages/signup/Manage.vue'),
  },
]
